var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',{staticClass:"p-3 s-inputx vs-input--input flex",attrs:{"config":_vm.datePickerConfig,"placeholder":"Choose arrival date and time","disabled":_vm.disableComponent},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }